export default {
    updateUserAccessDialogOpen(state, payload) {
        state.userAccessDialogOpen = payload;
    },

    updateGroupAccessDialogOpen(state, payload) {
        state.groupAccessDialogOpen = payload;
    },

    updateStats(state, payload) {
        Object.assign(state.stats, payload);
    }
}